import { CardWrapper } from "Components/Common/Card/index";
import { Hr } from "Components/Common/Hr/index";
import { LabelT6 } from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import { Spacer } from "Components/Common/Spacer/index";
import { TypographyT56 } from "Components/Common/Typography/index";
import { FlexWrapperT7 } from "Components/Common/Wrapper/FlexWrapper";
import { Wrapper } from "Components/EXIMCargoTracking/AdditionalFilesDetailsCard";
import Input from "Components/Input/index";
import React, { Fragment } from "react";
import { SingleDatePicker } from "react-dates";
import Moment from "moment";
import TimePicker from "rc-time-picker";
import { isDesmetSupplier } from "Utils/index";

const options = [
  { value: "supplier 01", label: "supplier 01" },
  { value: "supplier 02", label: "supplier 02" },
  { value: "supplier 03", label: "supplier 03" },
  { value: "supplier 04", label: "supplier 04" },
  { value: "supplier 05", label: "supplier 05" },
];

const CardT3 = (props) => {
  const {
    vehicleTypesList,
    vehicle_details,
    handleOnChangeForVehicleDetails,
    contact_details,
    handleOnChangeForContactDetails,
    tentative_pickup_date,
    focusedDateForTentativePickUpDate,
    handleOnDateChangeForTentativePickUpDate,
    handleOnFocusChangeDatePickerForTentativePickUpDate,
  } = props;
  return (
    <Fragment>
      <CardWrapper>
        <TypographyT56>Vehicle Details</TypographyT56>
        <Hr />
        <Spacer spacing={"4px"} />
        <Wrapper style={{ width: "fit-content" }}>
          <LabelT6>Recommended Vehicle Type</LabelT6>
          <Spacer spacing={"3px"} />
          <SelectT1
            placeholder={"Select"}
            isClearable={true}
            options={vehicleTypesList}
            isSearchable={true}
            value={vehicle_details}
            onChange={handleOnChangeForVehicleDetails}
          />
        </Wrapper>
        <Spacer spacing={"4px"} />
        <Wrapper style={{ width: "fit-content" }}>
          <LabelT6>Tentative Pick Up Date</LabelT6>
          <Spacer spacing={"3px"} />
          {/* <SelectT1
            placeholder={"Select"}
            isClearable={true}
            options={options}
            isSearchable={true}
            value={destinationYard}
            onChange={handleOnChangeDestinationYard}
          /> */}
          <SingleDatePicker
            placeholder="Select Date"
            noBorder={true}
            displayFormat={"DD MMM YYYY"}
            hideKeyboardShortcutsPanel={true}
            numberOfMonths={1}
            date={tentative_pickup_date}
            onDateChange={(date) => {
              handleOnDateChangeForTentativePickUpDate(date);
            }}
            focused={!!focusedDateForTentativePickUpDate}
            onFocusChange={({ focused }) => {
              handleOnFocusChangeDatePickerForTentativePickUpDate(focused);
            }}
            isOutsideRange={(day) => false}
          />
        </Wrapper>
        <Spacer spacing={"10px"} />
        <ContactDetails 
           contact_details={contact_details}
           handleOnChangeForContactDetails = {handleOnChangeForContactDetails}
        />
      </CardWrapper>
    </Fragment>
  );
};

export default CardT3;



export const ContactDetails = (props)=>{
  const { 
    contact_details={},
    handleOnChangeForContactDetails = ()=>{}
   } = props;

  return<Fragment>
  <TypographyT56>Contact Details</TypographyT56>
        <Spacer spacing={"4px"} />
         <FlexWrapperT7>
          <Wrapper className={"flex-1 "}>
            <LabelT6>Contact Person Name.</LabelT6>
            <Spacer spacing={"3px"} />
            <Input
              placeholder={"Enter here"}
              name={"contact_person_name"}
              value={contact_details.contact_person_name}
              onChange={handleOnChangeForContactDetails}
              disabled = {!isDesmetSupplier()}
            />
          </Wrapper>
          <Wrapper className={"flex-1 "}>
            <LabelT6>Contact No.</LabelT6>
            <Spacer spacing={"3px"} />
            <Input
              placeholder={"Enter here"}
              name={"contact_no"}
              value={contact_details.contact_no}
              onChange={handleOnChangeForContactDetails}
              disabled = {!isDesmetSupplier()}
            />
          </Wrapper>
        </FlexWrapperT7>
  </Fragment>

}